import { render, staticRenderFns } from "./PartPeriodPerformance.vue?vue&type=template&id=84c52c5c&scoped=true"
import script from "./PartPeriodPerformance.vue?vue&type=script&lang=ts"
export * from "./PartPeriodPerformance.vue?vue&type=script&lang=ts"
import style0 from "./PartPeriodPerformance.vue?vue&type=style&index=0&id=84c52c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c52c5c",
  null
  
)

export default component.exports